import { useEffect, useState } from 'react';
import { CHROME_EXTENSION_URL, FIREFOX_EXTENSION_URL } from './constants';

export interface ExtensionDetails {
  logo: string;
  href: string;
  browser: string;
}

export function useExtensionDetails(): ExtensionDetails {
  const [extensionDetails, setExtensionDetails] = useState<ExtensionDetails>({
    logo: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/chrome-logo.png`,
    href: CHROME_EXTENSION_URL,
    browser: 'Chrome',
  });

  useEffect(() => {
    const isFirefox =
      typeof window !== 'undefined' &&
      window.navigator.userAgent.indexOf('Firefox') > -1;

    if (isFirefox) {
      setExtensionDetails({
        logo: `${import.meta.env.VITE_STATIC_ASSETS_URL}/img/firefox-logo.png`,
        href: FIREFOX_EXTENSION_URL,
        browser: 'Firefox',
      });
    }
  }, []);

  return extensionDetails;
}

export function isChrome(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.navigator.userAgent.indexOf('Chrome') > -1 &&
    window.navigator.vendor.indexOf('Google') > -1 &&
    Object.prototype.hasOwnProperty.call(window, 'chrome')
  );
}

export function isFirefox(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.navigator.userAgent.indexOf('Firefox') > -1
  );
}
